var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { FaCog } from 'react-icons/fa';
import Versions from './Versions';
import Years from './Years';
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import { FiRefreshCcw } from 'react-icons/fi';
import { cellsApi, evaluatorApi } from '@data/rest/api';
import { toast } from 'react-hot-toast';
import { Page, PageTitle } from '@styled/Page';
import { appColors } from '@styled/useTheme';
import { useVersions } from '@data/hooks/versions';
import { useTimePoints } from '@data/hooks/timePoints';
import * as baobab from '@data/baobab/baobab';
import { useMaintenanceInfo, useSetMaintenance } from '../../../data/maintenance/maintenanceActions';
import { useAuth } from '../../../providers/AuthProvider';
function InputSetup() {
    var _this = this;
    var _a, _b, _c, _d;
    var L = useLanguage().L;
    var versions = (_a = useVersions().data) !== null && _a !== void 0 ? _a : [];
    var dts = (_b = useTimePoints().data) !== null && _b !== void 0 ? _b : [];
    var user = useAuth().user;
    var tenantId = baobab.root.get(['currentUser', 'tenantId']);
    var maintenanceInfo = useMaintenanceInfo(tenantId);
    var setMaintenance = useSetMaintenance();
    var calculateOnDemand = function () {
        toast.promise(cellsApi.calculateOnDemandCells(), {
            loading: 'Calculating...',
            success: 'Done',
            error: 'Failed to calculate',
        });
    };
    var refreshData = function () {
        toast.promise(evaluatorApi.invalidateCache(), {
            loading: 'Refreshing...',
            success: 'Done',
            error: 'Failed to refresh',
        });
    };
    return (React.createElement(Page, null,
        React.createElement(PageTitle, null,
            React.createElement(FaCog, { style: { color: appColors.primary.w500 } }),
            React.createElement("h2", null, L('Input Setup')),
            React.createElement(FSButton, { "$type": "secondary", title: L('On-Demand Calculation'), icon: FiRefreshCcw, onClick: calculateOnDemand, style: { marginLeft: 'auto' } }),
            React.createElement(FSButton, { "$type": "secondary", title: L('Refresh data'), icon: FiRefreshCcw, onClick: refreshData, style: { marginLeft: 8 } }),
            (user === null || user === void 0 ? void 0 : user.isSuperUser) && (React.createElement(FSButton, { style: { marginLeft: 8 }, "$color": ((_c = maintenanceInfo.data) === null || _c === void 0 ? void 0 : _c.maintenance) ? 'success' : 'error', loading: setMaintenance.isLoading, title: L(((_d = maintenanceInfo.data) === null || _d === void 0 ? void 0 : _d.maintenance) ? 'Disable Maintenance Mode' : 'Enable Maintenance Mode'), onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        setMaintenance.mutate({ tenantId: tenantId, value: !((_a = maintenanceInfo.data) === null || _a === void 0 ? void 0 : _a.maintenance) });
                        return [2 /*return*/];
                    });
                }); } }))),
        React.createElement("div", { className: "setup-content" },
            React.createElement(Versions, { versions: versions }),
            React.createElement(Years, { dts: dts }))));
}
export default InputSetup;
